/**
 * 401 "oturum düştü" MÜ, yoksa "girdiğin kimlik bilgisi yanlış" MI?
 * Sudo alanı taşıyan istekte 401 = yanlış şifre/kod demektir; alan-özel auth
 * kodları (INVALID_CODE/INVALID_CREDENTIALS) da öyle. Bunları oturum düşmesi
 * saymak, şifresini yanlış yazan kullanıcıyı HESABINDAN ATIYORDU (token silme +
 * /sign-in yönlendirmesi) ve sudo modalının "yeniden dene" akışını imkânsız
 * kılıyordu. Saf işlev — client.ts import-zamanı yan etkileri olmadan sınanır.
 */
export function isSessionDropping401(requestBody: unknown, responseBody: unknown): boolean {
  if (requestBody !== null && typeof requestBody === "object") {
    const b = requestBody as Record<string, unknown>;
    if (["password", "mfa_code", "sudo_proof"].some((k) => typeof b[k] === "string" && b[k] !== "")) return false;
  }
  if (responseBody !== null && typeof responseBody === "object") {
    const err = (responseBody as Record<string, unknown>).error;
    if (err === "INVALID_CODE" || err === "INVALID_CREDENTIALS") return false;
  }
  return true;
}
